export default [
    {
        date: 1530259918700,
        row: 25,
        col: 25,
        squares: [
            [1, 13, "#000000"],
            [2, 13, "#000000"],
            [3, 13, "#000000"],
            [4, 13, "#000000"],
            [5, 13, "#000000"],
            [6, 13, "#000000"],
            [7, 13, "#000000"],
            [8, 13, "#000000"],
            [9, 13, "#000000"],
            [10, 13, "#000000"],
            [11, 13, "#000000"],
            [12, 13, "#000000"],
            [13, 13, "#000000"],
            [14, 13, "#000000"],
            [15, 13, "#000000"],
            [16, 13, "#000000"],
            [17, 13, "#000000"],
            [20, 13, "#000000"],
            [19, 13, "#000000"],
            [18, 13, "#000000"],
            [21, 13, "#000000"],
            [22, 13, "#000000"],
            [23, 13, "#000000"],
            [24, 13, "#000000"],
            [25, 13, "#000000"],
            [13, 25, "#000000"],
            [13, 24, "#000000"],
            [13, 23, "#000000"],
            [13, 22, "#000000"],
            [13, 21, "#000000"],
            [13, 20, "#000000"],
            [13, 19, "#000000"],
            [13, 18, "#000000"],
            [13, 17, "#000000"],
            [13, 16, "#000000"],
            [13, 15, "#000000"],
            [13, 14, "#000000"],
            [13, 12, "#000000"],
            [13, 10, "#000000"],
            [13, 11, "#000000"],
            [13, 9, "#000000"],
            [13, 8, "#000000"],
            [13, 7, "#000000"],
            [13, 6, "#000000"],
            [13, 5, "#000000"],
            [13, 4, "#000000"],
            [13, 3, "#000000"],
            [13, 2, "#000000"],
            [13, 1, "#000000"],
            [2, 17, "#000000"],
            [2, 18, "#000000"],
            [2, 19, "#000000"],
            [2, 20, "#000000"],
            [2, 21, "#000000"],
            [2, 22, "#000000"],
            [3, 16, "#000000"],
            [4, 16, "#000000"],
            [5, 16, "#000000"],
            [6, 16, "#000000"],
            [7, 16, "#000000"],
            [8, 16, "#000000"],
            [3, 23, "#000000"],
            [4, 23, "#000000"],
            [5, 23, "#000000"],
            [6, 23, "#000000"],
            [7, 23, "#000000"],
            [8, 23, "#000000"],
            [9, 17, "#000000"],
            [9, 18, "#000000"],
            [9, 19, "#000000"],
            [9, 20, "#000000"],
            [9, 21, "#000000"],
            [9, 22, "#000000"],
            [2, 9, "#000000"],
            [2, 8, "#000000"],
            [2, 7, "#000000"],
            [2, 6, "#000000"],
            [2, 5, "#000000"],
            [2, 4, "#000000"],
            [3, 3, "#000000"],
            [4, 3, "#000000"],
            [5, 3, "#000000"],
            [8, 3, "#000000"],
            [7, 3, "#000000"],
            [6, 3, "#000000"],
            [3, 10, "#000000"],
            [4, 10, "#000000"],
            [5, 10, "#000000"],
            [6, 10, "#000000"],
            [7, 10, "#000000"],
            [8, 10, "#000000"],
            [9, 9, "#000000"],
            [9, 8, "#000000"],
            [9, 7, "#000000"],
            [9, 6, "#000000"],
            [9, 5, "#000000"],
            [9, 4, "#000000"],
            [24, 4, "#000000"],
            [24, 5, "#000000"],
            [24, 6, "#000000"],
            [24, 7, "#000000"],
            [24, 8, "#000000"],
            [24, 9, "#000000"],
            [23, 10, "#000000"],
            [22, 10, "#000000"],
            [21, 10, "#000000"],
            [20, 10, "#000000"],
            [19, 10, "#000000"],
            [18, 10, "#000000"],
            [17, 9, "#000000"],
            [17, 8, "#000000"],
            [17, 7, "#000000"],
            [17, 6, "#000000"],
            [17, 5, "#000000"],
            [17, 4, "#000000"],
            [18, 3, "#000000"],
            [19, 3, "#000000"],
            [20, 3, "#000000"],
            [21, 3, "#000000"],
            [22, 3, "#000000"],
            [23, 3, "#000000"],
            [24, 17, "#000000"],
            [24, 18, "#000000"],
            [24, 19, "#000000"],
            [24, 20, "#000000"],
            [24, 21, "#000000"],
            [24, 22, "#000000"],
            [23, 23, "#000000"],
            [22, 23, "#000000"],
            [21, 23, "#000000"],
            [20, 23, "#000000"],
            [19, 23, "#000000"],
            [18, 23, "#000000"],
            [17, 22, "#000000"],
            [17, 21, "#000000"],
            [17, 20, "#000000"],
            [17, 19, "#000000"],
            [17, 18, "#000000"],
            [17, 17, "#000000"],
            [18, 16, "#000000"],
            [19, 16, "#000000"],
            [20, 16, "#000000"],
            [21, 16, "#000000"],
            [22, 16, "#000000"],
            [23, 16, "#000000"],
            [3, 4, "#FF00FF"],
            [3, 22, "#FF00FF"],
            [23, 22, "#FF00FF"],
            [23, 4, "#FF00FF"],
            [22, 4, "#9900FF"],
            [23, 5, "#9900FF"],
            [23, 21, "#9900FF"],
            [22, 22, "#9900FF"],
            [4, 22, "#9900FF"],
            [3, 21, "#9900FF"],
            [3, 5, "#9900FF"],
            [4, 4, "#9900FF"],
            [5, 22, "#0000FF"],
            [4, 21, "#0000FF"],
            [3, 20, "#0000FF"],
            [3, 6, "#0000FF"],
            [4, 5, "#0000FF"],
            [5, 4, "#0000FF"],
            [21, 4, "#0000FF"],
            [22, 5, "#0000FF"],
            [23, 6, "#0000FF"],
            [23, 20, "#0000FF"],
            [22, 21, "#0000FF"],
            [21, 22, "#0000FF"],
            [20, 22, "#4A86E8"],
            [21, 21, "#4A86E8"],
            [22, 20, "#4A86E8"],
            [23, 19, "#4A86E8"],
            [23, 7, "#4A86E8"],
            [22, 6, "#4A86E8"],
            [21, 5, "#4A86E8"],
            [20, 4, "#4A86E8"],
            [6, 4, "#4A86E8"],
            [5, 5, "#4A86E8"],
            [4, 6, "#4A86E8"],
            [3, 7, "#4A86E8"],
            [3, 19, "#4A86E8"],
            [4, 20, "#4A86E8"],
            [5, 21, "#4A86E8"],
            [6, 22, "#4A86E8"],
            [7, 22, "#00FFFF"],
            [6, 21, "#00FFFF"],
            [5, 20, "#00FFFF"],
            [4, 19, "#00FFFF"],
            [3, 18, "#00FFFF"],
            [7, 4, "#00FFFF"],
            [6, 5, "#00FFFF"],
            [5, 6, "#00FFFF"],
            [4, 7, "#00FFFF"],
            [3, 8, "#00FFFF"],
            [19, 4, "#00FFFF"],
            [20, 5, "#00FFFF"],
            [21, 6, "#00FFFF"],
            [22, 7, "#00FFFF"],
            [23, 8, "#00FFFF"],
            [23, 18, "#00FFFF"],
            [22, 19, "#00FFFF"],
            [21, 20, "#00FFFF"],
            [20, 21, "#00FFFF"],
            [19, 22, "#00FFFF"],
            [3, 17, "#5CB85C"],
            [4, 18, "#5CB85C"],
            [5, 19, "#5CB85C"],
            [6, 20, "#5CB85C"],
            [7, 21, "#5CB85C"],
            [8, 22, "#5CB85C"],
            [18, 22, "#5CB85C"],
            [19, 21, "#5CB85C"],
            [20, 20, "#5CB85C"],
            [21, 19, "#5CB85C"],
            [22, 18, "#5CB85C"],
            [23, 17, "#5CB85C"],
            [23, 9, "#5CB85C"],
            [22, 8, "#5CB85C"],
            [21, 7, "#5CB85C"],
            [20, 6, "#5CB85C"],
            [19, 5, "#5CB85C"],
            [18, 4, "#5CB85C"],
            [8, 4, "#5CB85C"],
            [7, 5, "#5CB85C"],
            [6, 6, "#5CB85C"],
            [5, 7, "#5CB85C"],
            [4, 8, "#5CB85C"],
            [3, 9, "#5CB85C"],
            [4, 17, "#00FF00"],
            [5, 18, "#00FF00"],
            [6, 19, "#00FF00"],
            [7, 20, "#00FF00"],
            [8, 21, "#00FF00"],
            [18, 21, "#00FF00"],
            [19, 20, "#00FF00"],
            [20, 19, "#00FF00"],
            [21, 18, "#00FF00"],
            [22, 17, "#00FF00"],
            [22, 9, "#00FF00"],
            [21, 8, "#00FF00"],
            [20, 7, "#00FF00"],
            [19, 6, "#00FF00"],
            [18, 5, "#00FF00"],
            [8, 5, "#00FF00"],
            [7, 6, "#00FF00"],
            [6, 7, "#00FF00"],
            [5, 8, "#00FF00"],
            [4, 9, "#00FF00"],
            [5, 9, "#FFFF00"],
            [6, 8, "#FFFF00"],
            [7, 7, "#FFFF00"],
            [8, 6, "#FFFF00"],
            [5, 17, "#FFFF00"],
            [6, 18, "#FFFF00"],
            [7, 19, "#FFFF00"],
            [8, 20, "#FFFF00"],
            [18, 19, "#FF9900"],
            [19, 19, "#FFFF00"],
            [18, 20, "#FFFF00"],
            [20, 18, "#FFFF00"],
            [21, 17, "#FFFF00"],
            [21, 9, "#FFFF00"],
            [20, 8, "#FFFF00"],
            [19, 7, "#FFFF00"],
            [18, 6, "#FFFF00"],
            [6, 9, "#FF9900"],
            [7, 8, "#FF9900"],
            [8, 7, "#FF9900"],
            [6, 17, "#FF9900"],
            [7, 18, "#FF9900"],
            [8, 19, "#FF9900"],
            [19, 18, "#FF9900"],
            [20, 17, "#FF9900"],
            [20, 9, "#FF9900"],
            [19, 8, "#FF9900"],
            [18, 7, "#FF9900"],
            [7, 17, "#FF0000"],
            [8, 18, "#FF0000"],
            [18, 18, "#FF0000"],
            [19, 17, "#FF0000"],
            [18, 8, "#FF0000"],
            [19, 9, "#FF0000"],
            [8, 8, "#FF0000"],
            [7, 9, "#FF0000"],
            [8, 9, "#A61C00"],
            [8, 17, "#A61C00"],
            [18, 17, "#A61C00"],
            [18, 9, "#A61C00"],
            [1, 1, "#666666"],
            [1, 2, "#666666"],
            [2, 2, "#666666"],
            [2, 1, "#666666"],
            [4, 1, "#666666"],
            [3, 2, "#666666"],
            [3, 1, "#666666"],
            [4, 2, "#666666"],
            [5, 2, "#666666"],
            [5, 1, "#666666"],
            [6, 1, "#666666"],
            [7, 1, "#666666"],
            [6, 2, "#666666"],
            [7, 2, "#666666"],
            [8, 2, "#666666"],
            [9, 2, "#666666"],
            [9, 1, "#666666"],
            [8, 1, "#666666"],
            [10, 1, "#666666"],
            [11, 1, "#666666"],
            [12, 1, "#666666"],
            [12, 2, "#666666"],
            [12, 3, "#666666"],
            [12, 5, "#666666"],
            [12, 6, "#666666"],
            [12, 7, "#666666"],
            [12, 9, "#666666"],
            [12, 10, "#666666"],
            [12, 11, "#666666"],
            [12, 12, "#666666"],
            [11, 12, "#666666"],
            [11, 10, "#666666"],
            [11, 9, "#666666"],
            [11, 8, "#666666"],
            [12, 8, "#666666"],
            [11, 11, "#666666"],
            [11, 7, "#666666"],
            [11, 6, "#666666"],
            [11, 5, "#666666"],
            [11, 4, "#666666"],
            [12, 4, "#666666"],
            [11, 2, "#666666"],
            [11, 3, "#666666"],
            [10, 3, "#666666"],
            [9, 3, "#666666"],
            [10, 5, "#666666"],
            [10, 2, "#666666"],
            [10, 4, "#666666"],
            [10, 6, "#666666"],
            [10, 7, "#666666"],
            [10, 8, "#666666"],
            [10, 9, "#666666"],
            [10, 10, "#666666"],
            [10, 11, "#666666"],
            [2, 3, "#666666"],
            [1, 3, "#666666"],
            [1, 4, "#666666"],
            [1, 5, "#666666"],
            [1, 6, "#666666"],
            [1, 7, "#666666"],
            [1, 8, "#666666"],
            [1, 9, "#666666"],
            [1, 10, "#666666"],
            [1, 11, "#666666"],
            [1, 12, "#666666"],
            [2, 12, "#666666"],
            [2, 11, "#666666"],
            [2, 10, "#666666"],
            [3, 11, "#666666"],
            [3, 12, "#666666"],
            [4, 12, "#666666"],
            [4, 11, "#666666"],
            [5, 11, "#666666"],
            [5, 12, "#666666"],
            [6, 12, "#666666"],
            [6, 11, "#666666"],
            [7, 11, "#666666"],
            [8, 11, "#666666"],
            [8, 12, "#666666"],
            [7, 12, "#666666"],
            [9, 10, "#666666"],
            [9, 11, "#666666"],
            [9, 12, "#666666"],
            [10, 12, "#666666"],
            [14, 14, "#666666"],
            [15, 14, "#666666"],
            [16, 14, "#666666"],
            [17, 14, "#666666"],
            [18, 14, "#666666"],
            [19, 14, "#666666"],
            [20, 14, "#666666"],
            [21, 14, "#666666"],
            [23, 14, "#666666"],
            [24, 14, "#666666"],
            [22, 14, "#666666"],
            [25, 14, "#666666"],
            [25, 15, "#666666"],
            [25, 16, "#666666"],
            [25, 17, "#666666"],
            [25, 18, "#666666"],
            [25, 19, "#666666"],
            [25, 20, "#666666"],
            [25, 21, "#666666"],
            [25, 22, "#666666"],
            [25, 23, "#666666"],
            [25, 24, "#666666"],
            [25, 25, "#666666"],
            [24, 25, "#666666"],
            [23, 25, "#666666"],
            [22, 25, "#666666"],
            [21, 25, "#666666"],
            [20, 25, "#666666"],
            [19, 25, "#666666"],
            [18, 25, "#666666"],
            [17, 25, "#666666"],
            [16, 25, "#666666"],
            [15, 25, "#666666"],
            [14, 25, "#666666"],
            [14, 24, "#666666"],
            [14, 22, "#666666"],
            [14, 23, "#666666"],
            [14, 21, "#666666"],
            [14, 20, "#666666"],
            [14, 19, "#666666"],
            [14, 17, "#666666"],
            [14, 18, "#666666"],
            [14, 16, "#666666"],
            [14, 15, "#666666"],
            [15, 15, "#666666"],
            [16, 15, "#666666"],
            [17, 15, "#666666"],
            [18, 15, "#666666"],
            [19, 15, "#666666"],
            [20, 15, "#666666"],
            [21, 15, "#666666"],
            [22, 15, "#666666"],
            [24, 15, "#666666"],
            [23, 15, "#666666"],
            [24, 16, "#666666"],
            [24, 23, "#666666"],
            [24, 24, "#666666"],
            [23, 24, "#666666"],
            [22, 24, "#666666"],
            [21, 24, "#666666"],
            [20, 24, "#666666"],
            [19, 24, "#666666"],
            [18, 24, "#666666"],
            [17, 24, "#666666"],
            [16, 24, "#666666"],
            [15, 24, "#666666"],
            [15, 22, "#666666"],
            [15, 23, "#666666"],
            [15, 21, "#666666"],
            [15, 20, "#666666"],
            [15, 19, "#666666"],
            [15, 18, "#666666"],
            [15, 17, "#666666"],
            [15, 16, "#666666"],
            [16, 16, "#666666"],
            [16, 17, "#666666"],
            [17, 16, "#666666"],
            [16, 18, "#666666"],
            [16, 19, "#666666"],
            [16, 21, "#666666"],
            [16, 20, "#666666"],
            [16, 23, "#666666"],
            [16, 22, "#666666"],
            [17, 23, "#666666"],
            [14, 1, "#434343"],
            [15, 1, "#434343"],
            [16, 1, "#434343"],
            [17, 1, "#434343"],
            [18, 1, "#434343"],
            [19, 1, "#434343"],
            [20, 1, "#434343"],
            [22, 1, "#434343"],
            [23, 1, "#434343"],
            [21, 1, "#434343"],
            [14, 2, "#434343"],
            [14, 5, "#434343"],
            [14, 4, "#434343"],
            [14, 3, "#434343"],
            [14, 6, "#434343"],
            [14, 7, "#434343"],
            [14, 8, "#434343"],
            [14, 9, "#434343"],
            [14, 10, "#434343"],
            [14, 11, "#434343"],
            [14, 12, "#434343"],
            [15, 12, "#434343"],
            [16, 12, "#434343"],
            [17, 12, "#434343"],
            [18, 12, "#434343"],
            [19, 12, "#434343"],
            [20, 12, "#434343"],
            [21, 12, "#434343"],
            [22, 12, "#434343"],
            [23, 12, "#434343"],
            [22, 11, "#434343"],
            [23, 11, "#434343"],
            [15, 11, "#434343"],
            [16, 11, "#434343"],
            [17, 11, "#434343"],
            [18, 11, "#434343"],
            [19, 11, "#434343"],
            [21, 11, "#434343"],
            [20, 11, "#434343"],
            [15, 2, "#434343"],
            [16, 2, "#434343"],
            [17, 2, "#434343"],
            [18, 2, "#434343"],
            [19, 2, "#434343"],
            [20, 2, "#434343"],
            [21, 2, "#434343"],
            [22, 2, "#434343"],
            [23, 2, "#434343"],
            [17, 3, "#434343"],
            [16, 3, "#434343"],
            [15, 3, "#434343"],
            [15, 4, "#434343"],
            [15, 6, "#434343"],
            [15, 7, "#434343"],
            [15, 5, "#434343"],
            [15, 8, "#434343"],
            [15, 10, "#434343"],
            [15, 9, "#434343"],
            [16, 10, "#434343"],
            [17, 10, "#434343"],
            [16, 9, "#434343"],
            [16, 7, "#434343"],
            [16, 8, "#434343"],
            [16, 6, "#434343"],
            [16, 5, "#434343"],
            [16, 4, "#434343"],
            [24, 1, "#434343"],
            [24, 2, "#434343"],
            [24, 3, "#434343"],
            [25, 2, "#434343"],
            [25, 1, "#434343"],
            [25, 3, "#434343"],
            [25, 4, "#434343"],
            [25, 5, "#434343"],
            [25, 6, "#434343"],
            [25, 7, "#434343"],
            [25, 8, "#434343"],
            [25, 9, "#434343"],
            [25, 10, "#434343"],
            [24, 10, "#434343"],
            [24, 11, "#434343"],
            [25, 11, "#434343"],
            [24, 12, "#434343"],
            [25, 12, "#434343"],
            [1, 14, "#434343"],
            [3, 14, "#434343"],
            [2, 14, "#434343"],
            [4, 14, "#434343"],
            [5, 14, "#434343"],
            [6, 14, "#434343"],
            [7, 14, "#434343"],
            [9, 14, "#434343"],
            [10, 14, "#434343"],
            [8, 14, "#434343"],
            [11, 14, "#434343"],
            [12, 14, "#434343"],
            [12, 15, "#434343"],
            [10, 15, "#434343"],
            [11, 15, "#434343"],
            [9, 15, "#434343"],
            [8, 15, "#434343"],
            [6, 15, "#434343"],
            [7, 15, "#434343"],
            [5, 15, "#434343"],
            [4, 15, "#434343"],
            [3, 15, "#434343"],
            [2, 15, "#434343"],
            [1, 15, "#434343"],
            [1, 16, "#434343"],
            [2, 16, "#434343"],
            [1, 17, "#434343"],
            [1, 18, "#434343"],
            [1, 19, "#434343"],
            [1, 20, "#434343"],
            [1, 21, "#434343"],
            [1, 22, "#434343"],
            [1, 23, "#434343"],
            [2, 23, "#434343"],
            [1, 24, "#434343"],
            [2, 24, "#434343"],
            [3, 24, "#434343"],
            [1, 25, "#434343"],
            [2, 25, "#434343"],
            [3, 25, "#434343"],
            [4, 24, "#434343"],
            [4, 25, "#434343"],
            [5, 25, "#434343"],
            [5, 24, "#434343"],
            [6, 24, "#434343"],
            [6, 25, "#434343"],
            [7, 25, "#434343"],
            [7, 24, "#434343"],
            [8, 24, "#434343"],
            [9, 25, "#434343"],
            [8, 25, "#434343"],
            [9, 24, "#434343"],
            [9, 23, "#434343"],
            [10, 23, "#434343"],
            [11, 23, "#434343"],
            [10, 24, "#434343"],
            [11, 24, "#434343"],
            [10, 25, "#434343"],
            [11, 25, "#434343"],
            [12, 25, "#434343"],
            [12, 24, "#434343"],
            [12, 22, "#434343"],
            [12, 23, "#434343"],
            [12, 16, "#434343"],
            [12, 17, "#434343"],
            [12, 18, "#434343"],
            [12, 19, "#434343"],
            [12, 20, "#434343"],
            [12, 21, "#434343"],
            [11, 21, "#434343"],
            [10, 21, "#434343"],
            [10, 22, "#434343"],
            [11, 22, "#434343"],
            [10, 20, "#434343"],
            [11, 20, "#434343"],
            [10, 19, "#434343"],
            [11, 19, "#434343"],
            [11, 18, "#434343"],
            [10, 18, "#434343"],
            [10, 17, "#434343"],
            [11, 17, "#434343"],
            [10, 16, "#434343"],
            [9, 16, "#434343"],
            [11, 16, "#434343"],
        ],
    },

    {
        date: 1485419184455,
        row: 25,
        col: 25,
        squares: [
            [25, 9, "#000000"],
            [25, 15, "#000000"],
            [24, 16, "#000000"],
            [24, 14, "#000000"],
            [23, 14, "#000000"],
            [23, 16, "#000000"],
            [22, 16, "#000000"],
            [21, 16, "#000000"],
            [21, 17, "#000000"],
            [21, 18, "#000000"],
            [24, 10, "#000000"],
            [23, 10, "#000000"],
            [22, 11, "#000000"],
            [22, 12, "#000000"],
            [22, 13, "#000000"],
            [24, 8, "#000000"],
            [23, 8, "#000000"],
            [22, 8, "#000000"],
            [21, 8, "#000000"],
            [21, 7, "#000000"],
            [22, 7, "#000000"],
            [21, 9, "#008080"],
            [21, 10, "#008080"],
            [21, 11, "#008080"],
            [21, 12, "#008080"],
            [21, 13, "#008080"],
            [21, 14, "#008080"],
            [21, 15, "#008080"],
            [22, 15, "#008080"],
            [22, 14, "#008080"],
            [22, 10, "#008080"],
            [22, 9, "#008080"],
            [23, 9, "#008080"],
            [24, 9, "#008080"],
            [23, 15, "#008080"],
            [24, 15, "#008080"],
            [20, 7, "#808080"],
            [20, 8, "#808080"],
            [19, 9, "#808080"],
            [18, 9, "#808080"],
            [17, 8, "#808080"],
            [17, 7, "#808080"],
            [18, 6, "#808080"],
            [19, 6, "#808080"],
            [18, 7, "#FEC3AC"],
            [18, 8, "#FEC3AC"],
            [19, 8, "#FEC3AC"],
            [19, 7, "#FEC3AC"],
            [20, 17, "#808080"],
            [20, 18, "#808080"],
            [19, 19, "#808080"],
            [18, 19, "#808080"],
            [17, 18, "#808080"],
            [17, 17, "#808080"],
            [18, 16, "#808080"],
            [19, 16, "#808080"],
            [18, 17, "#FEC3AC"],
            [18, 18, "#FEC3AC"],
            [19, 18, "#FEC3AC"],
            [19, 17, "#FEC3AC"],
            [19, 13, "#800080"],
            [19, 14, "#800080"],
            [18, 14, "#800080"],
            [18, 13, "#800080"],
            [17, 14, "#800080"],
            [17, 13, "#800080"],
            [16, 14, "#800080"],
            [16, 13, "#800080"],
            [15, 12, "#800080"],
            [15, 14, "#800080"],
            [15, 13, "#800080"],
            [19, 5, "#000000"],
            [18, 5, "#000000"],
            [17, 5, "#000000"],
            [16, 6, "#000000"],
            [15, 6, "#000000"],
            [15, 7, "#000000"],
            [15, 17, "#000000"],
            [16, 18, "#000000"],
            [17, 19, "#000000"],
            [18, 20, "#000000"],
            [19, 20, "#000000"],
            [14, 18, "#000000"],
            [13, 19, "#000000"],
            [12, 20, "#000000"],
            [11, 20, "#000000"],
            [10, 20, "#000000"],
            [9, 20, "#000000"],
            [10, 18, "#000000"],
            [8, 20, "#000000"],
            [7, 20, "#000000"],
            [6, 20, "#000000"],
            [12, 19, "#FEC3AC"],
            [12, 18, "#FEC3AC"],
            [12, 17, "#FEC3AC"],
            [12, 16, "#FEC3AC"],
            [11, 16, "#FEC3AC"],
            [10, 16, "#FEC3AC"],
            [9, 16, "#FEC3AC"],
            [8, 16, "#FEC3AC"],
            [8, 18, "#FEC3AC"],
            [8, 19, "#FEC3AC"],
            [8, 17, "#FEC3AC"],
            [7, 19, "#FEC3AC"],
            [6, 19, "#FEC3AC"],
            [5, 20, "#000000"],
            [4, 19, "#000000"],
            [3, 18, "#000000"],
            [2, 19, "#955628"],
            [2, 20, "#000000"],
            [1, 19, "#000000"],
            [1, 17, "#000000"],
            [1, 18, "#000000"],
            [1, 16, "#000000"],
            [1, 15, "#000000"],
            [1, 14, "#000000"],
            [14, 5, "#000000"],
            [13, 4, "#000000"],
            [12, 3, "#000000"],
            [11, 2, "#000000"],
            [9, 2, "#000000"],
            [8, 2, "#000000"],
            [6, 2, "#000000"],
            [1, 10, "#000000"],
            [1, 11, "#000000"],
            [1, 12, "#000000"],
            [1, 13, "#000000"],
            [1, 9, "#000000"],
            [2, 8, "#000000"],
            [2, 7, "#000000"],
            [3, 6, "#000000"],
            [3, 5, "#000000"],
            [4, 4, "#000000"],
            [5, 3, "#000000"],
            [7, 2, "#000000"],
            [10, 2, "#000000"],
            [14, 6, "#955628"],
            [14, 7, "#955628"],
            [13, 7, "#955628"],
            [12, 7, "#955628"],
            [11, 7, "#955628"],
            [14, 8, "#FEC3AC"],
            [14, 9, "#FEC3AC"],
            [14, 10, "#FEC3AC"],
            [14, 11, "#FEC3AC"],
            [14, 12, "#FEC3AC"],
            [14, 13, "#FEC3AC"],
            [14, 14, "#FEC3AC"],
            [14, 15, "#FEC3AC"],
            [14, 16, "#FEC3AC"],
            [14, 17, "#FEC3AC"],
            [13, 8, "#FEC3AC"],
            [12, 8, "#FEC3AC"],
            [11, 8, "#FEC3AC"],
            [13, 9, "#FEC3AC"],
            [12, 9, "#FEC3AC"],
            [12, 10, "#FEC3AC"],
            [12, 11, "#FEC3AC"],
            [11, 9, "#FEC3AC"],
            [10, 9, "#FEC3AC"],
            [9, 9, "#FEC3AC"],
            [8, 9, "#FEC3AC"],
            [12, 12, "#FEC3AC"],
            [12, 13, "#FEC3AC"],
            [11, 13, "#FEC3AC"],
            [10, 13, "#FEC3AC"],
            [9, 13, "#FEC3AC"],
            [8, 13, "#FEC3AC"],
            [8, 12, "#FEC3AC"],
            [8, 11, "#FEC3AC"],
            [8, 10, "#FEC3AC"],
            [10, 11, "#000000"],
            [13, 11, "#FEC3AC"],
            [13, 10, "#FEC3AC"],
            [13, 12, "#FEC3AC"],
            [13, 13, "#000000"],
            [13, 14, "#000000"],
            [13, 15, "#000000"],
            [13, 16, "#000000"],
            [13, 17, "#FEC3AC"],
            [13, 18, "#FEC3AC"],
            [10, 8, "#FEC3AC"],
            [11, 6, "#FEC3AC"],
            [10, 6, "#FEC3AC"],
            [10, 7, "#955628"],
            [9, 7, "#955628"],
            [9, 8, "#955628"],
            [8, 8, "#955628"],
            [7, 8, "#955628"],
            [6, 9, "#955628"],
            [6, 10, "#955628"],
            [5, 11, "#955628"],
            [5, 12, "#955628"],
            [5, 13, "#955628"],
            [5, 14, "#955628"],
            [5, 15, "#955628"],
            [5, 16, "#955628"],
            [5, 17, "#955628"],
            [5, 18, "#955628"],
            [5, 19, "#955628"],
            [4, 18, "#955628"],
            [4, 17, "#955628"],
            [3, 17, "#955628"],
            [2, 17, "#955628"],
            [2, 18, "#955628"],
            [2, 16, "#955628"],
            [3, 16, "#955628"],
            [4, 16, "#955628"],
            [4, 15, "#955628"],
            [3, 15, "#955628"],
            [2, 15, "#955628"],
            [2, 14, "#955628"],
            [3, 14, "#955628"],
            [4, 14, "#955628"],
            [2, 13, "#955628"],
            [2, 9, "#955628"],
            [3, 7, "#955628"],
            [3, 8, "#955628"],
            [3, 9, "#955628"],
            [3, 10, "#955628"],
            [9, 6, "#955628"],
            [9, 5, "#955628"],
            [10, 5, "#955628"],
            [11, 5, "#955628"],
            [12, 5, "#955628"],
            [13, 5, "#955628"],
            [13, 6, "#955628"],
            [12, 6, "#955628"],
            [12, 4, "#955628"],
            [11, 4, "#955628"],
            [11, 3, "#955628"],
            [10, 3, "#955628"],
            [9, 3, "#955628"],
            [9, 4, "#955628"],
            [10, 4, "#955628"],
            [8, 3, "#955628"],
            [8, 4, "#955628"],
            [8, 5, "#955628"],
            [8, 6, "#955628"],
            [8, 7, "#955628"],
            [7, 7, "#955628"],
            [7, 6, "#955628"],
            [7, 5, "#955628"],
            [7, 4, "#955628"],
            [7, 3, "#955628"],
            [6, 4, "#955628"],
            [6, 3, "#955628"],
            [1, 8, "#000000"],
            [2, 6, "#000000"],
            [4, 13, "#955628"],
            [3, 13, "#955628"],
            [2, 12, "#955628"],
            [3, 12, "#955628"],
            [4, 12, "#955628"],
            [4, 11, "#955628"],
            [3, 11, "#955628"],
            [2, 11, "#955628"],
            [2, 10, "#955628"],
            [4, 10, "#955628"],
            [4, 9, "#955628"],
            [4, 8, "#955628"],
            [4, 7, "#955628"],
            [4, 6, "#955628"],
            [4, 5, "#955628"],
            [5, 5, "#955628"],
            [5, 4, "#955628"],
            [6, 5, "#955628"],
            [6, 6, "#955628"],
            [5, 6, "#955628"],
            [5, 7, "#955628"],
            [6, 7, "#955628"],
            [6, 8, "#955628"],
            [5, 8, "#955628"],
            [5, 9, "#955628"],
            [5, 10, "#955628"],
            [12, 14, "#FEC3AC"],
            [12, 15, "#FEC3AC"],
            [11, 15, "#000000"],
            [11, 14, "#000000"],
            [10, 14, "#FEC3AC"],
            [10, 15, "#000000"],
            [9, 15, "#FEC3AC"],
            [9, 14, "#FEC3AC"],
            [8, 14, "#FEC3AC"],
            [8, 15, "#FEC3AC"],
            [7, 9, "#FEC3AC"],
            [7, 10, "#FEC3AC"],
            [7, 11, "#FEC3AC"],
            [7, 12, "#FEC3AC"],
            [7, 13, "#FEC3AC"],
            [7, 14, "#FEC3AC"],
            [7, 15, "#FEC3AC"],
            [7, 16, "#FEC3AC"],
            [7, 17, "#FEC3AC"],
            [7, 18, "#FEC3AC"],
            [6, 18, "#FEC3AC"],
            [6, 17, "#FEC3AC"],
            [6, 16, "#FEC3AC"],
            [6, 14, "#FEC3AC"],
            [6, 12, "#FEC3AC"],
            [6, 13, "#FEC3AC"],
            [6, 11, "#FEC3AC"],
            [6, 15, "#FEC3AC"],
            [3, 19, "#000000"],
            [20, 19, "#000000"],
            [20, 6, "#000000"],
            [25, 8, "#000000"],
            [25, 10, "#000000"],
            [25, 14, "#000000"],
            [25, 16, "#000000"],
        ],
    },
];
